'use strict';

import register from './core';
import Handlebars from 'handlebars/dist/handlebars';

register('online-payment', function (element) {
  var $formPanel = $('#form-panel');
  var $confirmPanel = $('#confirm-panel');
  var $backButton = $('#back-button');
  var $formTemplate = $('#form-template');

  var init = function () {
    $confirmPanel.hide();
  };

  // This is used for the OnlinePayment block
  // The script below will remove the query from the callback after the page has loaded (from the browser url), 
  // to prevent the user from reloading the page and executing the payment check again.
  window.onload = function () {
    var locationSearch = window.location.search;
    if (locationSearch !== "" && locationSearch.indexOf("transactionId") !== -1 && locationSearch.indexOf("responseCode") !== -1) {
      var originlocation = window.location.origin + window.location.pathname;
      window.history.replaceState(null, null, originlocation);
    }
  };

  var getInputValues = function () {
    return {
      Name: $('#Name').val(),
      Email: $('#Email').val(),
      InvoiceNumber: $('#InvoiceNumber').val(),
      ApplicationNumber: $('#ApplicationNumber').val(),
      Reference: $('#Reference').val(),
      Amount: $('#Amount').val()
    }
  };

  init();
  $formPanel.submit(function (e) {
    e.preventDefault();
    $formPanel.hide();
    $confirmPanel.show();
    $('html, body').animate({
      scrollTop: ($confirmPanel.position().top - 20)
    }, 1000);
    var confirmTemplate = Handlebars.compile($("#template-confirm-form").html());
    var inputValues = getInputValues();
    $formTemplate.html(confirmTemplate({
      Name: inputValues.Name,
      Email: inputValues.Email,
      InvoiceNumber: inputValues.InvoiceNumber,
      ApplicationNumber: inputValues.ApplicationNumber,
      Reference: inputValues.Reference,
      Amount: inputValues.Amount
    }));
    validateForm($confirmPanel);
  });

  function validateForm($form) {
    var $refField = $("#Reference", $form);
    if ($refField.length) {
      var targetId = $refField.data('error-message-target');
      if ($refField.val().length > 18) {
        $("button.FormSubmitButton", $form).attr("disabled", "disabled");
        $(targetId).show();
      }
      else {
        $(targetId).hide();
        $("button.FormSubmitButton", $form).removeAttr("disabled");
      }
    }
  }

  $backButton.click(function (e) {
    e.preventDefault();
    $formPanel.show();
    $confirmPanel.hide();
    validateForm($confirmPanel);
  });
});
